import React, { useState } from 'react';
import { stylistAPI } from '../../../../services/api';
import { X } from 'lucide-react';

const AddLooksModal = ({ clientId, onClose, onAdded }) => {
  const [count, setCount] = useState(1);
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (count < 1) {
      alert('Количество должно быть больше 0');
      return;
    }

    setLoading(true);
    try {
      const result = await stylistAPI.addActionsToSubscription(clientId, count, note);
      onAdded(result);
    } catch (err) {
      console.error('Error adding actions:', err);
      alert(err.response?.data?.detail || 'Ошибка при добавлении действий');
    } finally {
      setLoading(false);
    }
  };

  const getActionWord = (n) => {
    if (n === 1) return 'действие';
    if (n >= 2 && n <= 4) return 'действия';
    return 'действий';
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--space-l)', zIndex: 1000 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: 'var(--white)', maxWidth: '400px', width: '100%' }}>
        <div style={{ padding: 'var(--space-l)', borderBottom: '1px solid var(--soft-gray)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.25rem', fontWeight: 400 }}>
            Пополнить подписку
          </h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: 'var(--space-l)' }}>
          <div style={{ marginBottom: 'var(--space-l)' }}>
            <label style={{ display: 'block', fontFamily: 'var(--font-body)', fontSize: '0.75rem', letterSpacing: '1px', textTransform: 'uppercase', color: 'var(--mid-gray)', marginBottom: 'var(--space-s)' }}>
              Количество действий
            </label>
            <p style={{ fontFamily: 'var(--font-body)', fontSize: '0.8125rem', color: 'var(--light-gray)', marginBottom: 'var(--space-m)' }}>
              Действие = 1 образ или 1 рекомендация к покупке
            </p>
            <div style={{ display: 'flex', gap: 'var(--space-s)' }}>
              {[1, 3, 5, 10].map((num) => (
                <button
                  key={num}
                  type="button"
                  onClick={() => setCount(num)}
                  style={{
                    flex: 1,
                    padding: '12px',
                    border: count === num ? '2px solid var(--warm-sage)' : '1px solid var(--soft-gray)',
                    backgroundColor: count === num ? 'rgba(143, 143, 126, 0.1)' : 'var(--white)',
                    cursor: 'pointer',
                    fontFamily: 'var(--font-body)',
                    fontSize: '1rem',
                    fontWeight: count === num ? 600 : 400
                  }}
                >
                  {num}
                </button>
              ))}
            </div>
            <input
              type="number"
              min="1"
              value={count}
              onChange={(e) => setCount(parseInt(e.target.value) || 1)}
              style={{
                width: '100%',
                marginTop: 'var(--space-s)',
                padding: '12px 16px',
                border: '1px solid var(--soft-gray)',
                fontFamily: 'var(--font-body)',
                fontSize: '0.875rem',
                textAlign: 'center'
              }}
            />
          </div>

          <div style={{ marginBottom: 'var(--space-l)' }}>
            <label style={{ display: 'block', fontFamily: 'var(--font-body)', fontSize: '0.75rem', letterSpacing: '1px', textTransform: 'uppercase', color: 'var(--mid-gray)', marginBottom: 'var(--space-s)' }}>
              Комментарий (опционально)
            </label>
            <input
              type="text"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Например: оплата, бонус..."
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '1px solid var(--soft-gray)',
                fontFamily: 'var(--font-body)',
                fontSize: '0.875rem'
              }}
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            style={{
              width: '100%',
              padding: '16px',
              backgroundColor: 'var(--warm-sage)',
              color: 'var(--white)',
              border: 'none',
              fontFamily: 'var(--font-body)',
              fontSize: '0.875rem',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? 'Добавление...' : `Добавить ${count} ${getActionWord(count)}`}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddLooksModal;
